export default __webpack_public_path__ + "static/media/carousel40.3f6c3df6.jpg";